import { useLocation } from "react-router-dom";

export const useSearchParams = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isPaymentSuccessful = searchParams.get("payment_success") === "true";
  const edit = searchParams.get("edit");

  return {
    edit,
    isPaymentSuccessful,
  };
};
